var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e0b32d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-home",
    "data-name": "Icon awesome-home",
    className: "cls-1",
    d: "M529.45,391,274.53,600.93V827.55a22.12,22.12,0,0,0,22.12,22.13l154.93-.4a22.11,22.11,0,0,0,22-22.22h0V694.72a22.13,22.13,0,0,1,22.14-22h88.49a22.12,22.12,0,0,1,22.12,22.12V827.06a22.12,22.12,0,0,0,22,22.2h.07l154.88.43a22.12,22.12,0,0,0,22.12-22.12V600.81L550.59,391A16.85,16.85,0,0,0,529.45,391ZM932.1,533.72,816.52,438.45V247a16.6,16.6,0,0,0-16.6-16.6H722.49a16.6,16.6,0,0,0-16.6,16.6V347.26L582,245.42a66.39,66.39,0,0,0-84.34,0L147.79,533.7a16.59,16.59,0,0,0-2.21,23.36v0l35.26,42.86a16.6,16.6,0,0,0,23.36,2.28h0L529.45,334.32a16.88,16.88,0,0,1,21.16,0L875.85,602.19A16.59,16.59,0,0,0,899.21,600l35.25-42.86a16.6,16.6,0,0,0-2.3-23.36Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b65e8aa4511413749f1124562a4da845.svg";
export { ForwardRef as ReactComponent };